import { FilePdfOutlined } from "@ant-design/icons";
import { Button } from "reactstrap";
import OpenSecurePdf from "../../../../common/file/openFile";
import "../../utils/detail.css";

const DocumentCard = ({ title, file, token }) => {
  if (!file) return null;

  return (
    <div className="document-card">
        <p className="document-title mt-4 mb-3">{title}</p>

        <FilePdfOutlined
          className="document-icon"
          style={{ fontSize: '100px', width: '100px', height: '100px' }}//J'ai appliqué le css pour eviter le rendu tardif
        />

        <Button
            title="Vous allez etre redirigés vers une autre page"
            className="view-btn mt-2"
            onClick={() => OpenSecurePdf(file, token)}
        >
            Voir
        </Button>
    </div>
  );
};

export default DocumentCard;